import React from "react";
import PropTypes from "prop-types";
import Parser from "html-react-parser";
import { animations } from "react-animation";
import "./FeaturesListing.css";

const root = process.env.REACT_APP_CMS_STATIC;

FeaturesListing.propTypes = {
  features: PropTypes.array,
  validateCustomButtons: PropTypes.bool, //valida si el feature contiene los tags de mostrarEnDetalle y/o mostrarEnListado (Asistencias)
};

function FeaturesListing({
  features = [],
  validateCustomButtons = false,
  ...props
}) {
  return (
    <div
      className="container-features"
      style={{ animation: animations.fadeIn }}
    >
      {features &&
        features.map((feature, index) => {
          return (
            <div key={index} className="feature-card">
              <div key={index}>
                <img
                  className="img img-fluid feature-card-image rounded-top"
                  src={feature.image}
                  alt={Parser(feature.title)}
                />
              </div>
              <h2 className="feature-card-title">
                {feature.url ? (
                  <a href={feature.url}>{Parser(feature.title)}</a>
                ) : (
                  Parser(feature.title)
                )}
              </h2>
              <div className="feature-card-texto">
                {Parser(feature.description)}
                <div className="feature-card-buttons">
                  {feature.buttons &&
                    feature.buttons.map((button, index) => {
                      return validateCustomButtons
                        ? button.mostrarEnListado && (
                            <a href={button.ruta.url} key={index}>
                              <img
                                key={index}
                                className="img img-fluid"
                                style={{ height: "50px" }}
                                src={Parser(root + button.imagen.urls[0])}
                                alt={button.displayText}
                              />
                            </a>
                          )
                        : (index === 0 || index === 1) && (
                            <a href={button.ruta.url} key={index}>
                              <img
                                key={index}
                                className="img img-fluid"
                                style={{ height: "50px" }}
                                src={Parser(root + button.imagen.urls[0])}
                                alt={button.displayText}
                              />
                            </a>
                          );
                    })}
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
}

export default FeaturesListing;
